import { createSlice } from '@reduxjs/toolkit';
import { getLists } from '../server/lists';

const initialListsState = {
    lists: [],
}

const listsSlice = createSlice({
    name: 'lists',
    initialState: initialListsState,
    reducers: {
        updateLists(state, actions) {
            state.lists = actions.payload;
        }
    }
});

export const listsActions = listsSlice.actions;
export default listsSlice;

export const fetchLists = () => {
    return async (dispatch) => {
        try {
            const res = await getLists();
            const listsData = res.data;
            dispatch(listsActions.updateLists(listsData || []));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}